(ns frontend.account
  (:require
   [cljsjs.device]
   [common.entity :as entity]
   [common.localization :as loc]
   [common.util :as cu]
   [frontend.ag-grid :as ag-grid]
   [frontend.db :as db]
   [frontend.heap-io :as heap-io]
   [frontend.intercom :as intercom]
   [frontend.local-storage :as ls]
   [frontend.logging :as logging]
   [frontend.state.current-session :as session :refer [prod?]]
   [potpuri.core :refer [dissoc-in]]
   [reagent.core :as r]))

;;
;; Saved account state:
;;

(defn saved-state
  []
  (ls/get :account))

;;
;; Account API:
;;

(defn session [] @db/session)
(defn account-state
  []
  (-> @(r/track session)
      :state
      (or :pending)))
(defn account
  []
  (-> @(r/track session)
      :account))
(defn tenant
  []
  (-> @(r/track session)
      :tenant))
(defn role
  []
  (-> @(r/track session)
      :role))
(defn roles
  []
  (-> @(r/track session)
      :roles))

(defn- merge-session
  [state updates]
  (let [state (merge state updates)]
    (assoc state
           :state
           (cond
             (:role state) :role
             (:account state) :account
             :else :none))))

(defn actor-display-name
  [entity-or-id & {:keys [middle-of-sentence?]}]
  (let [actor (get @session/entities entity-or-id entity-or-id)]
    (cond (= (:db/id @session/account)
             (or (:db/id actor) entity-or-id))
          (loc/tr (if middle-of-sentence?
                :you--middle-of-sentence
                :you))
          (number? actor)
          (loc/tr :system)
          :else
          (entity/display-string actor))))

(defn update-session
  [& updates]
  (let [updates (apply hash-map updates)
        tenant-name (:tenant/name (:tenant updates))]
    (swap! db/app-state update :session merge-session updates)

    (swap! db/app-state dissoc-in [:views :login :password])
    (swap! db/app-state dissoc-in [:views :login :username])

    (ls/update :account
               merge
               (cond-> {}
                       ;(contains? updates :token) (assoc :token (:token updates))
                       (contains? updates :tenant) (assoc :tenant-id
                                                          (-> updates
                                                              :tenant
                                                              :db/id))
                       (contains? updates :role) (assoc :role (:role updates))
                       (contains? updates :role-id) (assoc :role-id (:role updates))
                       (contains? updates :target) (assoc :target-id
                                                          (-> updates
                                                              :target
                                                              :db/id))))
    (ls/set :switching-tenant? (boolean (:switching-tenant? updates)))
    (swap! db/app-state assoc :switching-tenant? (boolean (:switching-tenant? updates)))

    (when (and tenant-name
               #_(not (session/dev?)))
      (let [acc (account)]
        (js/console.log "Init intercome")
        (when (and (not (session/is-mobile?))
                   (not (cu/blank-value? (:intercom-id @db/app-state)))
                   (:intercom-hash updates))
          (intercom/activate (:intercom-id @db/app-state)
                             (:intercom-hash updates)
                             acc
                             {:tenant (:tenant updates)}))))

    (ag-grid/init (:ag-grid-license-key @db/app-state))

;; TODO: check whether it's safe to call multiple times
    (when (and (session/heap-analytics?)
               (:heap-io-id @db/app-state))
      (heap-io/initialize (:account/analytics-user-id (account)) (:heap-io-id @db/app-state)))

    (when (:token updates)
      (when (some #{(:device-type @db/session)} [:ios :android])
        ;; SEND TOKEN TO iOS and Android App container!
        ;; - ONLY When device-type has been set to :ios or :android, normal browser will show a warning message
        (set! (.-location js/window) (str "hybrid:update-session?token=" (:token updates)))))))

(def DEBUG-SESSION false)

(defn reset-session
  []
  (when-not DEBUG-SESSION
    (aset js/window.location "href" "/logout")
    (intercom/shutdown)
    (ls/set :switching-tenant? nil)
    (ls/set :account nil)
    (ls/set :current-module nil)
    (logging/error "Logging out")))
